// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"c7ee2960","787":"aa17ddbf"}[chunkId] + ".chunk.js";
};